import createIcon from '../../createIcon';

/**
 * @component @name Deck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOUwxMiAyTDIgOUgxMVYyMkgxM1Y5SDIyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTQuMTQgMTJMMi4xOCAxMi4zN0wzIDE2Ljc0VjIySDVMNS4wMiAxOEg3VjIySDlWMTZINC45TDQuMTQgMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkuMSAxNkgxNVYyMkgxN1YxOEgxOC45OEwxOSAyMkgyMVYxNi43NEwyMS44MiAxMi4zN0wxOS44NiAxMkwxOS4xIDE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Deck = createIcon('Deck', [
  ['path', { d: 'M22 9L12 2L2 9H11V22H13V9H22Z', key: '14t5ae' }],
  ['path', { d: 'M4.14 12L2.18 12.37L3 16.74V22H5L5.02 18H7V22H9V16H4.9L4.14 12Z', key: 'n7k75b' }],
  [
    'path',
    { d: 'M19.1 16H15V22H17V18H18.98L19 22H21V16.74L21.82 12.37L19.86 12L19.1 16Z', key: 'lk0e6k' },
  ],
]);

export default Deck;
